import type { Components } from '@mui/material/styles';

export default function MUIStepIcon(): Components['MuiStepIcon'] {
  return {};
}
